import sendMessage from "./sendMessage";
import dotFlowCallback from "./dotFlowCallback";
import { SET_EDITED } from "../actions/edited";

export default () => (dispatch, getState) => {
  const { edited } = getState();

  dispatch({ type: SET_EDITED, payload: true });

  if (edited) return Promise.resolve();

  return dispatch(dotFlowCallback("___NOTIFICATIONS_UPDATED___"));
};



// WEBPACK FOOTER //
// ./src/store/epics/sendConfirmation.js